export default __webpack_public_path__ + "static/clarence2-c54c689a11bc2985b87465f36c9321dd.jpg";